import process from "node:process";
import type { AppMeta } from "@calcom/types/App";

export const metadata = {
  name: "Cal Video",
  description:
    "Cal Video is the in-house web-based video conferencing platform powered by Daily.co, which is minimalistic and lightweight, but has most of the features you need.",
  // GoCal: Cal Video is intentionally removed; never list it as installed even if DAILY_API_KEY is set
  installed: false,
  type: "daily_video",
  variant: "conferencing",
  url: "https://daily.co",
  categories: ["conferencing"],
  logo: "icon.svg",
  publisher: "Goletro",
  category: "conferencing",
  slug: "daily-video",
  title: "Cal Video",
  // GoCal: was `true`; isGlobal injects a fake credential in getApps() which forces Cal Video
  // into the location dropdown regardless of `installed`. Keep false to hide it everywhere.
  isGlobal: false,
  email: "https://goletro.com/contact",
  appData: {
    location: {
      linkType: "dynamic",
      type: "integrations:daily",
      label: "Cal Video",
    },
  },
  key: { apikey: process.env.DAILY_API_KEY },
  dirName: "dailyvideo",
  isOAuth: false,
} as AppMeta;

export default metadata;
